const mutations = {
  // 设置登陆状态
  muSetApiLoginStatus(state, status) {
    state.isApiLoginStatus = status;
  },
  // 设置本地存储中的用户信息
  muSetUserInfo(state, info) {
    state.userInfo = info;
    state.userId = info.uid || info.userId;
  },
  // 设置微信授权信息
  muSetWxUserInfo(state, info) {
    state.wxUserInfo = info;
  },
  // 设置服务器时间
  muServerDate(state, data) {
    state.serverDate = data;
  },

  muFocusWxcode(state, status) {
    state.isFocusWxcode = status;
  },
};

export default mutations;
